import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectChattelDetailsState = createSelector(
  selectLoanApplication,
  ({ chattelDetails }) => chattelDetails ?? {},
);

export const selectChattelDetails = createSelector(
  selectChattelDetailsState,
  ({ details }) => details,
);

// The chattel-details endpoint has no server-side pending-changes/history feed (unlike
// property-and-loan-summary), so the EditModal's cross-user pending-changes selector is a stable
// empty object -- the nav-tab "N changes" badge is still driven by the live form diff.
const EMPTY_CHATTEL_PENDING_CHANGES = {};

export const selectChattelDetailsPendingChanges = () => EMPTY_CHATTEL_PENDING_CHANGES;
